import { Text, useColorModeValue, VStack } from '@chakra-ui/react';
import React from 'react';

import type { FormFields } from '../types';

import { CONTRACT_LICENSES } from 'lib/contracts/licenses';
import { useI18n } from 'lib/i18n/context';
import FormFieldFancySelect from 'ui/shared/forms/fields/FormFieldFancySelect';

import ContractVerificationFormRow from '../ContractVerificationFormRow';
import { CONTRACT_VERIFICATION_FIELD_KEYS } from '../i18n';

const options = CONTRACT_LICENSES.map(({ label, title, type }) => ({ label: `${ title } (${ label })`, value: type }));

const ContractVerificationFieldLicenseType = () => {
  const { t } = useI18n();
  const descColor = useColorModeValue('#616161', '#747474');

  return (
    <VStack align="stretch" spacing={{ base: 4, lg: 8 }}>
      <ContractVerificationFormRow>
        <FormFieldFancySelect<FormFields, 'license_type'>
          name="license_type"
          placeholder={ t(CONTRACT_VERIFICATION_FIELD_KEYS.licenseType.placeholder) }
          options={ options }
        />
      </ContractVerificationFormRow>
      <Text color={ descColor } fontSize="16px" fontFamily="'Space Grotesk', sans-serif" fontWeight={ 500 }>
        { t(CONTRACT_VERIFICATION_FIELD_KEYS.licenseType.description) }
      </Text>
    </VStack>
  );
};

export default React.memo(ContractVerificationFieldLicenseType);
